export default __webpack_public_path__ + "static/media/ifp.b191cf7c.jpg";